/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './reset-password-component.service';
export * from './reset-password.component';
export * from './reset-password.module';
